import React from "react";

const formatNumber = (num) => {
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(2) + "M";
  if (num >= 1_000) return (num / 1_000).toFixed(2) + "K";
  return num.toLocaleString();
};

const CoverageBar = ({ 
  percentCovered, 
  selectedVariantsCount, 
  totalVariants, 
  selectedCases, 
  totalCases 
}) => (
  <div className="mb-4">
    <div className="text-sm text-gray-600 mb-1">
      Coverage: {selectedVariantsCount} / {totalVariants} variants selected
    </div>
    <div className="flex items-center justify-between gap-4 w-full">
      <div className="flex-grow bg-gray-200 h-5 rounded-full overflow-hidden flex items-center">
        <div 
          className="bg-primary-500 h-full flex items-center justify-center text-white text-xs font-semibold rounded-full transition-all duration-400 px-2 whitespace-nowrap"
          style={{ width: `${Math.max(percentCovered, 8)}%` }}
        >
          {percentCovered.toFixed(1)}%
        </div>
      </div>
      <div className="text-sm text-gray-700 whitespace-nowrap">
        <strong className="font-semibold text-gray-800">
          {formatNumber(selectedCases)} / {formatNumber(totalCases)}
        </strong> cases
      </div>
    </div>
  </div>
);

export default CoverageBar;
